exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3VDyWHnY4QY1L3K_7IVP9r{font-size:14px;color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] ._3VDyWHnY4QY1L3K_7IVP9r{margin-left:2px}html[dir=rtl] ._3VDyWHnY4QY1L3K_7IVP9r{margin-right:2px}._3CrP4nGL_hnatLtmbDZXtH{top:2px;position:relative}", ""]);
// Exports
exports.locals = {
	"chevronButton": "_3VDyWHnY4QY1L3K_7IVP9r",
	"chevronButtonOuter": "_3CrP4nGL_hnatLtmbDZXtH"
};